import React from 'react';

import APIClient from './APIClient';
import Alert from './Alert';

class ProfileForm extends React.Component {
  state = {
    error: null,
    dailyEmails: null,
    stylishEmails: null,
    comics: null,
  };

  componentDidMount() {
    APIClient.shared.getProfile()
      .then(({ comics, dailyEmails, stylishEmails })=> this.setState({ comics, dailyEmails, stylishEmails }))
      .catch(error => this.setState({ error }))
  }

  handleDailyEmailsChange = () => {
    this.setState(state => {
      const dailyEmails = !state.dailyEmails;

      APIClient.shared.postProfile('dailyEmails', dailyEmails)
        .catch(error => this.setState({ error }));

      return { dailyEmails };
    });
  };

  handleStylishEmailsChange = () => {
    this.setState(state => {
      const stylishEmails = !state.stylishEmails;

      APIClient.shared.postProfile('stylishEmails', stylishEmails)
        .catch(error => this.setState({ error }));

      return { stylishEmails };
    });
  };

  handleComicChange = (e, prevComic) => {
    const comic = { ...prevComic };
    comic.enabled = !comic.enabled;

    this.setState(prevState => {
      const comics = [...prevState.comics];
      const index = comics.findIndex(c => c.id === comic.id);
      comics[index] = comic;

      APIClient.shared.postProfile('comic', { id: comic.id, enabled: comic.enabled })
        .catch(error => this.setState({ error }));

      return { comics };
    });
  };

  render() {
    const Comic = (props) => {
      const id = `comic_${props.comic.id}`;

      return (
        <div className="Form__group Form__check">
          <input
            id={id}
            type="checkbox"
            checked={props.comic.enabled}
            onChange={(e) => this.handleComicChange(e, props.comic)}
          />
          <label htmlFor={id}>{props.comic.name}</label>
        </div>
      );
    };

    return (
      <div className="ProfileForm">
        {this.state.error !== null &&
          <Alert title="Error" message={this.state.error.message} />
        }
        {this.state.dailyEmails !== null &&
          <form className="Form">
            <h2>Emails</h2>
            <div className="Form__group Form__check">
              <input
                id="dailyEmails"
                type="checkbox"
                checked={this.state.dailyEmails}
                onChange={this.handleDailyEmailsChange}
              />
              <label htmlFor="dailyEmails">Receive daily emails</label>
              <p>Daily at 11:00 am, we will send you an email with all the new comics since the previous email.</p>
            </div>

            <div className="Form__group Form__check">
              <input
                id="stylishEmails"
                type="checkbox"
                checked={this.state.stylishEmails}
                onChange={this.handleStylishEmailsChange}
              />
              <label htmlFor="stylishEmails">Include custom styles</label>
              <p>Use the Panels colour scheme in the daily email.</p>
            </div>

            <h2>Comics</h2>
            {this.state.comics !== null && this.state.comics.map(comic => <Comic key={comic.id} comic={comic} />)}
          </form>
        }
      </div>
    );
  }
}

export default ProfileForm;



// WEBPACK FOOTER //
// ./src/ProfileForm.js